module.exports = __webpack_public_path__ + "media/about_employee/nyc-3c222353.png";